var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from "react";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import useToast from "../../hooks/useToast";
import { buildMutationToastStrings, groupSkipDaysByMonth, SkipDayLoadingText, updateLoadingText, updateSkipDay, } from "./skipDaysQuery-utils";
import { SWR_KEYS } from "../Utilities/swrKeys";
import { apFetcher } from "../Utilities/axiosPrivateFetcher_SWR";
/**
 * This hook fetches skip day configurations and all available skip days for a customer.
 */
export const useSkipDaysQuery = () => {
    var _a, _b, _c;
    const toast = useToast();
    const { datadogLog } = useLogging();
    const [loadingText, setLoadingText] = useState(SkipDayLoadingText.LOADING);
    //* ===== SWR QUERY =====
    const { data, error, isLoading } = useSWR(SWR_KEYS.SKIP_DAYS, apFetcher("/Account/GetSkipDays"), {
        onSuccess: (data, error) => {
            if (!data.success) {
                const errorMessage = new Error(error);
                datadogLog("Skip Days fetch error", LogLevel.ERROR, undefined, errorMessage);
            }
        },
        onError: (error) => {
            datadogLog("Skip Days error", LogLevel.ERROR, undefined, error);
        },
    });
    //* ===== SWR SKIP DAYS MUTATION =====
    const { trigger: triggerUpdate, isMutating } = useSWRMutation(SWR_KEYS.SKIP_DAYS, updateSkipDay, {
        onError: (error) => {
            datadogLog("Skip Days update error", LogLevel.ERROR, undefined, error);
        },
        populateCache: true,
    });
    //* ===== SWR SKIP DAYS MUTATION TRIGGER FUNCTION =====
    const triggerUpdateSkipDay = (date, skip) => __awaiter(void 0, void 0, void 0, function* () {
        updateLoadingText(date, skip, setLoadingText);
        try {
            yield triggerUpdate({ date, skip });
            buildMutationToastStrings(date, skip, true, toast);
        }
        catch (err) {
            buildMutationToastStrings(date, skip, false, toast);
        }
        finally {
            setLoadingText(SkipDayLoadingText.LOADING);
        }
    });
    return {
        allSkipDays: data === null || data === void 0 ? void 0 : data.skipDays,
        configuration: data === null || data === void 0 ? void 0 : data.configuration,
        error: (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "",
        hasSkipDays: !!((_b = data === null || data === void 0 ? void 0 : data.skipDays) === null || _b === void 0 ? void 0 : _b.length),
        isLoading,
        isMutating,
        loadingText,
        skipDaysByMonth: groupSkipDaysByMonth(data === null || data === void 0 ? void 0 : data.skipDays),
        skippedDays: (_c = data === null || data === void 0 ? void 0 : data.skipDays) === null || _c === void 0 ? void 0 : _c.filter((skipDay) => skipDay.skip === true),
        triggerUpdateSkipDay,
    };
};
